function withSetupTeardown(setup, teardown) {
  return (next) => (reducer, preloadedState) => ({
    ...next(reducer, preloadedState),
    setup,
    teardown
  });
}
export {
  withSetupTeardown
};
//# sourceMappingURL=setup-teardown.js.map